<template>
  <div class="tab__content" :class="classes">
    <slot></slot>
  </div>
</template>

<script>
  export default {
     data() {
        return {
           isActive: this.active
        }
     },
    props: {
      name: { type: String, default: null },
      active: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
    },
    computed: {
       classes() {
          const { isActive } = this
          return [
             isActive ? 'active' : null
          ]
       }
    }
  }
</script>

<style lang="scss" scoped>
@import '~/assets/SCSS/Elements/tab.scss';
</style>